import React from 'react';
import { HeaderPrimaryButton } from '../buttons/HeaderPrimaryButton';
import style from './AccountLoginButtonRow.module.scss';
import { useAperzaUserContext } from '../AperzaUserContext';
import { addUtmParam } from '../../addUtmParam';
export function AccountLoginButtonRow() {
    const { serviceType, signUpUrl, loginUrl } = useAperzaUserContext();
    return (React.createElement("div", { className: style.menuRow },
        React.createElement(HeaderPrimaryButton, { disableArrow: true, href: addUtmParam(loginUrl(), 'header', serviceType), buttonClassName: style.signButton }, "\u30ED\u30B0\u30A4\u30F3"),
        React.createElement(HeaderPrimaryButton, { outlined: true, disableArrow: true, href: addUtmParam(signUpUrl(), 'header', serviceType), buttonClassName: style.signButton }, "\u4F1A\u54E1\u767B\u9332\uFF08\u7121\u6599\uFF09")));
}
